/** Normalize display copy on saved estimates as well as newly generated quotes. */
export function customerQuoteExclusions(lines: readonly string[]): string[] {
  return lines.map(line => line
    .replace(/Sales tax is additional; it is not included in the package or deposit shown\.?/gi, '')
    .replace(/Sales tax (?:is )?additional\.?\s*/gi, '')
    .replace(/sales tax,\s*/gi, '')
    .trim()).filter(Boolean);
}
